import { STATIC_PATH } from '@shared/constants/ImageConstants';

export const LABELS = {
    USERNAME: 'Username',
    EMAIL: 'Email',
    SELECT_LABEL: 'Access Type',
};

export const BACK_BUTTON_VARIANT = 'outlined';

export const GENERIC_TEAM_SCREEN_MODAL_TEXTS = {
    DELETE_INVITE_TITLE: 'Delete Invite',
    DELETE_MEMBER_TITLE: 'Delete Team Member',
    SEND_INVITE_TITLE: 'Invite new members',
    DELETE_SUBTITLE: "This action can't be undone.\nAre you sure about it?",
    SEND_INVITE_SUBTITLE: 'Send invitation links to new members and choose an ideal Access Type for them.',
    SEND_INVITE_SUCCEEDED: 'Your invitation has been successfully sent',
    DELETE_INVITE_SUCCESS_MESSAGE: 'Your invitation has been successfully canceled.',
    DELETE_USER_SUCCESS_MESSAGE: 'User {username} has been deleted from your team.',
    DELETE_BUTTON_NAME: 'Delete',
    BACK_BUTTON_NAME: 'Back',
    SEND_INVITE_BUTTON_NAME: 'Send Invite',
    INPUT_SEND_INVITE_PLACEHOLDER: 'tess@pareto.io',
    SELECT_PLACEHOLDER: 'Select access type',
    OPEN_DELETE_MODAL_FAILED: 'Your access type does not allow this action. Only Admin users can delete users.',
    OPEN_INVITE_MODAL_FAILED: 'Your access type does not allow this action. Only Admin users can invite users.',
    INVALID_ROLE_ERROR_MESSAGE: 'Access Type is a required field. Select an access type option to proceed',
    INVITE_BUTTON_NAME: 'Add New Member',
    EMAIL_ALREADY_INVITED_MESSAGE: 'There is already an invitation sent to this email. Please ask this user to check their email inbox.',
    INVITEE_IS_ALREADY_A_MEMBER: "This user is already in your team. It's not possible to send invitations to members of your team.",
    INVITEE_OWN_EMAIL: "This is your own e-mail. It's not possible to send this invitation.",
    INVITEE_ALREADY_IN_A_TEAM: "This user already belongs to another team. It's not possible to invite users in other teams.",
};

export const GENERIC_TEAM_SCREEN_MODAL_TEXTS_SIZES = {
    HEADER_CLOSE_BUTTON: 36,
};

export const IMG_PATH = `${STATIC_PATH}/deleteInviteModalImg.png`;

export const MODAL_TEST_IDS = {
    GENERIC_MODAL: 'GENERIC_MODAL_ID',
    STYLED_CLOSE_BUTTON_WRAPPER: 'STYLED_CLOSE_BUTTON_WRAPPER_ID',
    CLOSE_WORKFLOW_MODAL_ICON: 'CLOSE_WORKFLOW_MODAL_ICON_ID',
    PARETO_LOGO: 'PARETO_LOGO_ID',
    INPUT_INVITE: 'INPUT_INVITE_ID',
    INPUT_EMAIL: 'INPUT_EMAIL_ID',
    INPUT_USERNAME: 'INPUT_USERNAME_ID',
    BUTTONS_WRAPPER: 'BUTTONS_WRAPPER_ID',
    DELETE_BUTTON: 'DELETE_BUTTON_ID',
    BACK_BUTTON: 'BACK_BUTTON',
    SELECT_ACCESS_TYPE: 'SELECT_ACCESS_TYPE',
    SELECT_ACCESS_TYPE_WRAPPER: 'SELECT_ACCESS_TYPE_WRAPPER',
    SEND_INVITE_BUTTON_ID: 'SEND_INVITE_BUTTON_ID',
    TOOLTIP: 'TOOLTIP',
};

export const ROLE_OPTIONS = [
    { value: 'Admin', label: 'Admin' },
    { value: 'Member', label: 'Member' },
];

export const TOOLTIP_CONSTANTS = {
    TITLE: `Member: Full access to the software, being  
able to configure and apply all automation
and analysis tools. It cannot manage the team or grant and remove access.
        
Admin: Full access to the software, including
the complete management of the users of
your team.`,
    SUBTITLE: 'Access Type',
};

export const SEND_INVITE_API_ERROR = {
    EMAIL_ALREADY_INVITED: 'Email invited already',
    INVALID_EMAIL: "{'email': [ErrorDetail(string='Enter a valid email address.', code='invalid')]}",
    INVALID_ROLE: "{'role': [ErrorDetail(string='\"\" is not a valid choice.', code='invalid_choice')]}",
    INVALID_EMAIL_AND_INVALID_ROLE: "{'email': [ErrorDetail(string='Enter a valid email address.', code='invalid')], 'role': [ErrorDetail(string='\"\" is not a valid choice.', code='invalid_choice')]}",
    BLANK_EMAIL: "{'email': [ErrorDetail(string='This field may not be blank.', code='blank')]}",
    BLANK_FIELDS: "{'email': [ErrorDetail(string='This field may not be blank.', code='blank')], 'role': [ErrorDetail(string='\"\" is not a valid choice.', code='invalid_choice')]}",
    INVITEE_IS_ALREADY_A_MEMBER: 'This user is already in your team.',
    INVITEE_OWN_EMAIL: "You can't invite yourself",
    INVITEE_ALREADY_IN_A_TEAM: 'Invitee already in a team',
};
